/*
 * cfg-cart-lock.js
 * Browserlaag van het groepsslot: houdt de verplichte zakjes vast aan hun set.
 * Alle beslissingen komen uit CfgCartGroup (assets/cfg-cart-group.js); dit bestand
 * doet alleen DOM en fetch.
 *
 * Twee verantwoordelijkheden:
 *   1. Klikken op de verwijderlink en de steppers van een SET vertalen naar één
 *      update over de hele groep.
 *   2. Bewaken: na elke cart-wijziging controleren of elke groep nog compleet is.
 *
 * Waarom allebei: (1) is het normale pad, (2) vangt de rest af — de /cart-pagina die
 * met volledige navigatie werkt, een rechtstreeks aangeroepen
 * /cart/change?line=2, en winkelwagens die al openstonden.
 *
 * assets/theme.js wordt niet aangeraakt (vendorbestand, staat niet in git).
 */
(function () {
  'use strict';

  var G = window.CfgCartGroup;
  if (!G) return;

  // Eén vlag voor beide paden. De bewaker reageert op cart-wijzigingen en veroorzaakt
  // er zelf; zonder deze vlag zou hij op zijn eigen updates reageren.
  var bezig = false;

  function haalCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function verversThema(cart, vertraging) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { cart: cart, replacementDelay: vertraging || 0 }
    }));
  }

  /*
   * Het thema toont zijn laadspinner en de uitvloei-animatie via de events die
   * LineItemQuantity normaal vuurt (zie LineItem in assets/theme.js). Wij vangen die
   * klik af met preventDefault, dus die events komen er niet — zonder deze twee
   * functies gebeurt er zichtbaar níéts tot de klant ververst, terwijl de wijziging
   * op de server allang verwerkt is.
   *
   * De cart-pagina gebruikt een <tr> zonder loader; daar doen deze events niets, en
   * dat is prima.
   */
  function startLader(regelEl, nieuwAantal) {
    if (!regelEl) return;
    regelEl.dispatchEvent(new CustomEvent('line-item-quantity:change:start', {
      bubbles: true,
      detail: { newLineQuantity: nieuwAantal }
    }));
  }

  function stopLader(regelEl, cart, nieuwAantal) {
    if (!regelEl) return;
    regelEl.dispatchEvent(new CustomEvent('line-item-quantity:change:end', {
      bubbles: true,
      detail: { cart: cart, newLineQuantity: nieuwAantal }
    }));
  }

  function stuurUpdates(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  function stuurToevoegingen(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- 1. Groepsacties op de setregel ---------- */

  /*
   * Ververst ALTIJD aan het einde, ook als er niets te herstellen viel. Dat is het
   * verschil met de bewaker: die grijpt alleen in bij een afwijking, maar een
   * geslaagde groepsactie is juist het normale geval en moet gewoon zichtbaar worden.
   */
  function pasGroepAan(uid, nieuwAantal, regelEl) {
    if (bezig) return Promise.resolve();
    bezig = true;
    startLader(regelEl, nieuwAantal);
    return haalCart()
      .then(function (cart) {
        var updates = G.bepaalGroepsUpdate(cart, uid, nieuwAantal);
        if (!Object.keys(updates).length) return null;
        return stuurUpdates(updates);
      })
      .then(herstelStil)
      .then(haalCart)
      .then(function (cart) {
        bezig = false;
        stopLader(regelEl, cart, nieuwAantal);
        // Dezelfde vertraging als het thema zelf aanhoudt, zodat de uitvloei-animatie
        // van de regel niet halverwege door een herrender wordt afgekapt.
        verversThema(cart, nieuwAantal === 0 ? 600 : 750);
      })
      .catch(function (err) {
        bezig = false;
        console.warn('[cfg-lock] groepsactie mislukt:', err);
        // Toch herrenderen, anders blijft de winkelwagen een stand tonen die niet
        // meer klopt met wat er op de server staat.
        return haalCart().then(function (cart) { verversThema(cart); }).catch(function () {});
      });
  }

  function rolVan(el) {
    var regel = el.closest && el.closest('[data-cfg-uid][data-cfg-role="main"]');
    return regel || null;
  }

  /*
   * Capture-fase, zodat we vóór het thema zitten: LineItemQuantity vangt dezelfde
   * klik af en zou op de /cart-pagina meteen wegnavigeren.
   */
  document.addEventListener('click', function (event) {
    var el = event.target.closest && event.target.closest('a');
    if (!el) return;
    var regel = rolVan(el);
    if (!regel) return;

    var uid = regel.getAttribute('data-cfg-uid');
    var huidig = parseInt(regel.getAttribute('data-cfg-qty'), 10) || 1;
    var nieuw = null;

    if (el.classList.contains('line-item__remove-button')) {
      nieuw = 0;
    } else if (el.classList.contains('quantity-selector__button')) {
      var match = (el.getAttribute('href') || '').match(/[?&]quantity=(\d+)/);
      if (!match) return;
      nieuw = parseInt(match[1], 10);
    } else {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (nieuw === huidig) return;
    pasGroepAan(uid, nieuw, regel);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('.quantity-selector__input')) return;
    var regel = rolVan(input);
    if (!regel) return;
    event.preventDefault();
    event.stopPropagation();
    pasGroepAan(regel.getAttribute('data-cfg-uid'), parseInt(input.value, 10), regel);
  }, true);

  /* ---------- 2. De bewaker ---------- */

  /*
   * Het herstelwerk zelf, zonder herrender en zonder de bezig-vlag: zo kan
   * pasGroepAan hem meenemen in zijn eigen keten en één keer aan het eind
   * verversen. Geeft terug of er daadwerkelijk iets is gewijzigd.
   */
  function herstelStil() {
    return haalCart().then(function (cart) {
      var plan = G.bepaalHerstel(cart);
      if (!plan.toevoegen.length && !Object.keys(plan.bijwerken).length) return false;

      var keten = Promise.resolve();
      // Eerst bijwerken, dan toevoegen: een update werkt op line keys, en die
      // schuiven niet op. Een toevoeging kan wel een nieuwe regel opleveren.
      if (Object.keys(plan.bijwerken).length) {
        keten = keten.then(function () { return stuurUpdates(plan.bijwerken); });
      }
      if (plan.toevoegen.length) {
        keten = keten.then(function () { return stuurToevoegingen(plan.toevoegen); });
      }
      return keten.then(function () { return true; });
    });
  }

  function bewaak() {
    if (bezig) return Promise.resolve();
    bezig = true;
    return herstelStil()
      .then(function (gewijzigd) {
        if (!gewijzigd) return null;
        return haalCart().then(function (cart) { verversThema(cart); });
      })
      .then(function () { bezig = false; })
      .catch(function (err) {
        bezig = false;
        console.warn('[cfg-lock] herstel mislukt:', err);
      });
  }

  document.documentElement.addEventListener('cart:updated', function () { bewaak(); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bewaak(); });
  } else {
    bewaak();
  }
})();
